import React, { useMemo } from 'react';

/**
 * ReproductorPieza — reproductor de audio o video que se superpone sobre la
 * página impresa donde está el bloque multimedia.
 *
 * En el papel esa página lleva un código QR; aquí el lector no necesita
 * escanear nada: le da play sin salir de la revista.
 *
 * El archivo vive en el bucket privado del periódico, así que se pide por el
 * proxy del backend, que lo descarga con las credenciales de la aplicación.
 */
export default function ReproductorPieza({ datos, onCerrar }) {
  const esVideo = datos?.tipo === 'video';

  const fuente = useMemo(() => {
    if (datos?.url) return datos.url;
    if (!datos?.gsUri) return null;
    const base = (process.env.REACT_APP_API_URL || 'http://localhost:5000') + '/api/v1';
    return `${base}/storage/proxy?gsUri=${encodeURIComponent(datos.gsUri)}`;
  }, [datos]);

  if (!fuente) return null;

  return (
    <div style={{
      position: 'absolute', inset: 0, zIndex: 20,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 14,
      background: 'rgba(12,12,12,0.93)', padding: 20,
    }}>
      <div style={{ textAlign: 'center', color: '#fff', maxWidth: 640 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', color: '#c9a227' }}>
          {esVideo ? 'VIDEO' : 'AUDIO'}
        </div>
        <div style={{ fontSize: 19, fontWeight: 600, marginTop: 4, lineHeight: 1.25 }}>
          {datos?.titulo}
        </div>
        {datos?.autoria && (
          <div style={{ fontSize: 12, opacity: .65, marginTop: 3 }}>{datos.autoria}</div>
        )}
      </div>

      {esVideo ? (
        <video
          src={fuente}
          poster={datos?.portadaUrl || undefined}
          controls
          preload="metadata"
          style={{ maxWidth: 'min(90vw, 820px)', maxHeight: '60vh',
                   borderRadius: 6, background: '#000' }}
        />
      ) : (
        <div style={{ width: 'min(90vw, 560px)' }}>
          {datos?.portadaUrl && (
            <img src={datos.portadaUrl} alt=""
                 style={{ width: '100%', borderRadius: 6, marginBottom: 10,
                          maxHeight: '38vh', objectFit: 'cover' }} />
          )}
          <audio src={fuente} controls preload="metadata" style={{ width: '100%' }} />
        </div>
      )}

      <button
        onClick={onCerrar}
        style={{
          fontSize: 12, padding: '6px 14px', borderRadius: 16,
          border: '1px solid rgba(255,255,255,.3)', background: 'transparent',
          color: '#fff', cursor: 'pointer',
        }}
      >Ver la página</button>
    </div>
  );
}
